import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();
export const GetListBranch = (pageIndex = 1, pageSize = 10, sortExpression = "", searchData = undefined) => {
    const params = new URLSearchParams();
    params.append("pageIndex", pageIndex);
    params.append("pageSize", pageSize);
    sortExpression && params.append("sorting", sortExpression);
    searchData?.name && params.append("name", searchData.name);
    searchData?.description && params.append("description", searchData.description);
    searchData?.isDeleted != undefined && params.append("isDeleted", searchData.isDeleted);
    searchData?.isActived != undefined && params.append("isActived", searchData.isActived);
    return service.get(ApiUrl.GetListBranch, params).then((res) => { return res }).catch((err) => { throw err });
}
export const GetDetailBranch = (id) => {
    return service.get(ApiUrl.GetDetailBranch.replace("{id}", id)).then(res => { return res }).catch((err) => { throw err });
}
export const CreateBranch = (data) => {
    return service.post(ApiUrl.CreateBranch, data).then((res) => { return res }).catch(err => { throw err });
}
export const UpdateBranch = (data) => {
    return service.put(ApiUrl.UpdateBranch, data).then((res) => { return res }).catch(err => { throw err });
}
export const DeleteBranch = (id) => {
    return service.delete(ApiUrl.DeleteBranch.replace("{id}", id)).then((res) => { return res }).catch(err => { throw err });
}
export const DeletePermanentBranch = (id) => {
    return service.delete(ApiUrl.DeletePermanentBranch.replace("{id}", id)).then((res) => { return res }).catch(err => { throw err });
}
export const ActiveBranch = (id) => {
    return service.put(ApiUrl.ActiveBranch.replace("{id}", id)).then((res) => { return res }).catch(err => { throw err });
}
export const DeActiveBranch = (id) => {
    return service.put(ApiUrl.DeActiveBranch.replace("{id}", id)).then((res) => { return res }).catch(err => { throw err });
}
export const GetLookupBranch = () => {
    return service.get(ApiUrl.GetLookupBranch).then((res) => { return res }).catch((err) => { throw err });
}
